import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UsersProvider } from '../../../users/providers/users-provider';
import { PhaseProvider } from '../../providers/phase-provider.services';
import { AnnualPlanDialogFormPhaseComponent } from '../../components/dialog-form-phase/annual-plan-dialog-form-phase.component';
import { AnnualPlanDialogFormMacrocycleComponent } from '../../components/dialog-form-macrocycle/annual-plan-dialog-form-macrocycle.component';
import { AnnualPlanRow, AnnualPlanService } from '../../providers/annual-plans.services';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AnnualPlanDialogFormAttributeComponent } from '../../components/dialog-form-attribute/annual-plan-dialog-form-attribute.component';
import { BreadcrumbProvider, Crumb } from '../../../breadcrumb/providers/breadcrumb-provider';
import { AnnualPlanRights } from '../../providers/annual-plan-rights';
import { CurrentUserRolesProvider } from '../../../organizations/providers/current-user-roles-provider';
import { Title } from '@angular/platform-browser';
import { forkJoin, Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfigProvider } from "../../../config-provider.service";
import { ModuleMenu } from "../../../common/models/menu";
import { Organization } from "../../../common/models/organization";
import { Athlete } from "../../../common/models/athlete";
import { User } from "../../../common/models/user";
import { AnnualPlanPhase } from "../../../common/models/annual-plan.phase";
import { Week } from "../../../common/models/week";
import { AnnualPlan } from "../../../common/models/annual-plan";
import { AnnualPlanMacroCycle } from "../../../common/models/annual-plan-macro-cycle";
import { ExerciceCategory } from "../../../common/models/exercice-category";
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { CurrentUser } from "../../../common/providers/current-user";
import { HasPendingChangesGuard } from "../../../common/guards/has-pending-changes";
import { ErrorManagerService } from "../../../common/providers/error-manager-service";
import { ExercicesProvider } from "../../../exercices/providers/exercices-provider";
import { ArrayUtils } from "../../../common/providers/array-utils";
import { ApiError } from "../../../common/error/api-error";
import { OrganizationRole } from "../../../common/models/organization-role";
import { PageContentComponent } from "../../../common/components/page-content/page-content";
import { HeaderComponent } from "../../../common/components/header-elitment/header-elitment";
import { SideMenuComponent } from "../../../common/components/side-menu/side-menu";
import { AthleteSideMenuComponent } from "../../../athletes/components/side-menu/side-menu";
import { Error401Component } from "../../../common/components/error-401/error-401";
import { Error404Component } from "../../../common/components/error-404/error-404";
import { ModuleContentComponent } from "../../../common/components/module-content/module-content";
import { NgForOf, NgIf } from "@angular/common";
import { AnnualPlanSideMenuWeekEditComponent } from "../../components/site-menu-week-edit/side-menu-week-edit";
import { MatTooltip } from "@angular/material/tooltip";
import { MatMiniFabButton } from "@angular/material/button";
import { AnnualPlanGraphComponent } from "../../components/graph/annual-plan-graph.component";
import { FlexLayoutModule } from "@angular/flex-layout";
import { Phase } from "../../../common/models/phase";
import { MainActionComponent } from "../../../common/components/main-action/main-action";
import { EffectivePlanGraphComponent } from "../../components/graph/effective-plan-graph.component";
import { MatError, MatFormField } from "@angular/material/form-field";
import { CdkTextareaAutosize } from "@angular/cdk/text-field";
import { MatInput } from "@angular/material/input";
import { SecondsToDHMPipe } from "../../../common/pipes/seconds-to-DHM-pipe";
import { DefaultPipe } from "../../../common/pipes/default";
import { ApiBaseService } from "../../../common/providers/api-base-service";
import { LibraryService } from "../../../libraries/providers/library.services";
import {
  AnnualPlanDialogFormAthletePlanNewComponent
} from "../../components/dialog-form-athlete-plan-new/annual-plan-dialog-form-athlete-plan-new.component";
import { AthletesProvider } from "../../../athletes/providers/athletes-provider";
import { map } from "rxjs/operators";
import { AthleteCoach } from "../../../common/models/athlete-coach";
import { Library } from "../../../common/models/library";

@Component({
  selector: 'app-annual-plan-athlete-show',
  templateUrl: './annual-plan-athlete-show.component.html',
  styleUrls: ['./annual-plan-athlete-show.scss'],
  imports: [
    PageContentComponent,
    HeaderComponent,
    SideMenuComponent,
    AthleteSideMenuComponent,
    Error401Component,
    Error404Component,
    ModuleContentComponent,
    NgIf,
    AnnualPlanSideMenuWeekEditComponent,
    MatTooltip,
    MatMiniFabButton,
    TranslateModule,
    MatSlideToggle,
    AnnualPlanGraphComponent,
    FlexLayoutModule,
    MainActionComponent,
    EffectivePlanGraphComponent,
    MainActionComponent,
    MainActionComponent,
    MatError,
    MatFormField,
    CdkTextareaAutosize,
    ReactiveFormsModule,
    MatInput,
    SecondsToDHMPipe,
    DefaultPipe,
    NgForOf,

  ],
  standalone: true
})
export class AnnualPlanAthleteShowComponent implements OnInit, OnDestroy {

    get f() {
        return this.annualPlanForm.controls;
    }
    public mainActions: ModuleMenu[] = [];
    public pageTitle = 'AnnualPlanShow';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public titleSwitcherItems: ModuleMenu[] = [];

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public annualPlan: AnnualPlan = {} as AnnualPlan;

    public weeks: Week[] = [];
    public isEditMode = false;
    public clickedWeek: Week | undefined;
    public phases: Phase[] = [];

    public exerciseCategories: ExerciceCategory[] = [];
    public annualPlanMacroCycles: AnnualPlanMacroCycle[] = [];
    public annualPlanMacroCyclesToDelete: number[] = [];
    public annualPlanPhases: AnnualPlanPhase[] = [];
    public annualPlanPhasesToDelete: number[] = [];
    public annualPlanRights: AnnualPlanRights = new AnnualPlanRights(this.utils);

    public isSubmitting = false;
    public annualPlanForm: FormGroup;

    public showEffectivePlan = false;
    public scrollPosition: number | null = null;

    private weeksToUpdate: any = [];
    private phaseDialog: any;
    private macroCycleDialog: any;
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        public dialog: MatDialog,
        public breadcrumbProvider: BreadcrumbProvider,
        private route: ActivatedRoute,
        private userProvider: UsersProvider,
        private exerciseProvider: ExercicesProvider,
        private phaseProvider: PhaseProvider,
        private annualPlanService: AnnualPlanService,
        private router: Router,
        private toaster: MatSnackBar,
        private translater: TranslateService,
        private arrayUtils: ArrayUtils,
        private fb: FormBuilder,
        private _title: Title,
        private api: ApiBaseService,
        private utils: UtilsProvider,
        private currentUser: CurrentUser,
        private currentUserRoles: CurrentUserRolesProvider,
        private changesGuard: HasPendingChangesGuard,
        // private authorizationChecker: AuthorizationChecker,
        private errorManagerService: ErrorManagerService,
        private ts: TranslateService,
        private librariesProvider: LibraryService,
        private athletesProvider: AthletesProvider,
    ) {
        this.route.paramMap.subscribe( (map: any) => {
          this.isEditMode = 'edit' === map['params']['edit'];
        })
        // use the FormBuilder to create a form group
        this.annualPlanForm = this.fb.group({
            comment: new FormControl('', [Validators.maxLength(5000)])
        });
    }

    @HostListener('window:beforeunload')
    public doSomething() {
        return !this.changesGuard.hasChanges();
    }

    public ngOnInit() {
      this.loadData()
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }

    public switchAnnualPlan(annualPlan: AnnualPlan) {
        this.router.navigate([
            this.organization!.code + '/athletes/' + this.athleteUser.id + '/plans/' + annualPlan.id
        ]);
    }

    public weekEventClicked(week: Week) {
        this.clickedWeek = week;
    }

    public weeksChanged(weeks: Week[]) {
        this.weeks = weeks;
    }

    public onChangeComment() {
        this.changesGuard.registerChanges(() => this.onSaveClicked());
    }

    public onDuplicateAsModel() {
      this.librariesProvider.getByOrganizationCode(this.organization.code!).subscribe({
        next: (library) => {
          const toDuplicate = {
              id: this.annualPlan.id,
              title: this.annualPlan.title + ' (1)',
              athleteId: this.annualPlan.athleteId,
              weeksLength: this.annualPlan.weeksLength,
              weeklyWorkingTime: this.annualPlan.weeklyWorkingTime,
              availableLangIds: this.annualPlan.availableLangIds,
              comment: this.annualPlan.comment,
              startedAt: this.annualPlan.startedAt
          };

          const dialogRef: any = this.dialog.open(AnnualPlanDialogFormAthletePlanNewComponent, {
              data: {
                  dialogTitle: 'Make_a_model',
                  formSaveActionTitle: 'Save',
                  annualPlanRow: toDuplicate,
                  organization: this.organization,
                  athlete: this.athleteUser.athlete,
                  duplicateAsModel: true,
                  skipLangSelection: true,
                  library,
                  isLangSelectable: true
              }
          });

          // Update the list by fetching all objects after dialog closed
          this.subscriptions.push(
              dialogRef.afterClosed().subscribe((row: AnnualPlanRow) => {
                  if (row) {
                      this.toaster.open(this.translater.instant('Plan_saved_as_model'), '', { duration: 5000 });
                  }
              })
          );
        }
      })
    }

    /**
     * Create an unique array of Week elements to update
     *
     * @param week
     */
    public weekUpdated(week: Week) {
        this.changesGuard.registerChanges(() => this.onSaveClicked());

        const element = this.weeksToUpdate.find((x:any) => x.id === week.id);
        if (!element) {
            this.weeksToUpdate.push(week);
        } else {
            Object.assign(element, week);
        }
    }

    public onSaveClicked(): Promise<boolean> {

        return new Promise<boolean>((resolve, reject) => {
            this.isLoading = true;

            if (this.annualPlanForm.valid) {
                this.save()
                    .then(() => {
                        this.isLoading = false;
                        this.changesGuard.unregisterChanges();
                        this.toaster.open(this.translater.instant('AnnualPlan_Saved'), '', { duration: 5000 });
                        resolve(true);
                    })
                    .catch((error: any) => {
                        this.isLoading = false;

                        // this.onError(error);
                        resolve(false);
                    });
            } else {
                this.isLoading = false;
                resolve(false);
            }
        });
    }

    public save(): Promise<any> {
        return new Promise<any>((resolve, reject) => {
            const savePlan = new Promise((res, rej) => {
                Object.assign(this.annualPlan, this.annualPlanForm.value, {organization: this.organization});

                this.subscriptions.push(
                    this.annualPlanService.edit(this.annualPlan).subscribe((plan) => {
                        res(plan);
                    }, (error) => rej(error))
                );
            });

            const saveWeeks = new Promise<void>((res, rej) => {
                this.subscriptions.push(
                    this.annualPlanService.saveWeeks(this.organization, this.annualPlan, this.weeksToUpdate).subscribe(() => {
                        res();
                    }, (error) => rej(error))
                );
            });

            const saveMacroCycles = new Promise<void>((res, rej) => {
                this.subscriptions.push(
                    this.annualPlanService.saveMacroCycles(this.organization, this.annualPlan, this.annualPlanMacroCycles, true).subscribe((response) => {
                        this.subscriptions.push(
                            this.annualPlanService.findByPlanId(this.organization.code!, this.athleteUser.id!, this.annualPlan.id!).subscribe((data) => {
                                // Edits and deletes find a cycle by its tag: reloaded cycles need fresh ones.
                                this.annualPlanMacroCycles = data.macroCycles.map((macroCycle: AnnualPlanMacroCycle) =>
                                    Object.assign(macroCycle, {tag: this.utils.getUniqTag()}));
                                res();
                            }, (error) => rej(error))
                        );
                    }, (error) => rej(error))
                );
            });

            const savePhases = new Promise<void>((res, rej) => {
                this.subscriptions.push(
                    this.annualPlanService.savePhases(this.organization, this.annualPlan, this.annualPlanPhases, true).subscribe(() => {
                        res();
                    }, (error) => {
                        rej(error);
                    }
                    ));
            });

            const deletePhases = new Promise<void>((res, rej) => {
                this.annualPlanPhasesToDelete.map((phaseId) => {
                    this.subscriptions.push(
                        this.annualPlanService.deletePhases(this.organization, this.annualPlan, phaseId).subscribe()
                    );
                });

                res();
            });

            const deleteMacroCycles = new Promise<void>((res, rej) => {
                this.annualPlanMacroCyclesToDelete.map((macroCycleId) => {
                    this.subscriptions.push(
                        this.annualPlanService.deleteMacroCycles(this.organization, this.annualPlan, macroCycleId).subscribe()
                    );
                });

                res();
            });

            Promise.all([savePlan, saveWeeks, saveMacroCycles, savePhases, deletePhases, deleteMacroCycles])
                .then(() => {
                    this.changesGuard.unregisterChanges();
                    resolve(true);
                }, (err) => {
                    let message = this.translater.instant('Error_unknown');
                    if (err instanceof ApiError) {
                        message = err.title;
                    }

                    this.toaster.open(message, '', {duration: 5000});
                    reject(err);
                });
        });
    }

    public handleGraphScroll(event: any) {
        this.scrollPosition = event;
    }

    public addPhaseEvent(week: Week) {
        this.phaseDialog = this.dialog.open(AnnualPlanDialogFormPhaseComponent, {
            data: {
                organization: this.organization,
                annualPlan: this.annualPlan,
                week,
                weeks: this.weeks,
                annualPlanPhases: this.annualPlanPhases,
                dialogTitle: 'PhaseAdd',
            }
        });

        this.subscriptions.push(
            this.phaseDialog.afterClosed().subscribe((data: any) => {

                // add a phase to corresponding week
                if (data && data.annualPlanPhase && !data?.toDelete) {

                    // ajoute un tag
                    data.annualPlanPhase.tag = this.utils.getUniqTag();

                    // ajoute aux phases
                    this.annualPlanPhases.push(data.annualPlanPhase);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public annualPlanPhaseClickedEvent(annualPlanPhase: AnnualPlanPhase) {
        this.phaseDialog = this.dialog.open(AnnualPlanDialogFormPhaseComponent, {
            data: {
                organization: this.organization,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                annualPlanPhase,
                annualPlanPhases: this.annualPlanPhases,
                dialogTitle: 'PhaseEdit',
            }
        });

        this.subscriptions.push(
            this.phaseDialog.afterClosed().subscribe((data: any) => {

                // c'est une suppression
                if (data && data.toDelete && data.annualPlanPhase) {
                    if (!annualPlanPhase.id) return ;

                    // liste des phases existantes à supprimer
                    this.annualPlanPhasesToDelete.push(annualPlanPhase.id);

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanPhases.findIndex((e) => e.tag === data.annualPlanPhase.tag);
                    this.annualPlanPhases.splice(index, 1);
                    // this.arrayUtils.removeFromArrayByReference(this.annualPlanPhases, annualPlanPhase);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }

                // this is an update
                if (data && !data.toDelete && data.annualPlanPhase) {

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanPhases.findIndex((e) => e.tag === data.annualPlanPhase.tag);
                    this.annualPlanPhases[index] = data.annualPlanPhase;

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public addMacroCycleEvent(week: Week) {
        this.macroCycleDialog = this.dialog.open(AnnualPlanDialogFormMacrocycleComponent, {
            data: {
                organization: this.organization,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                week,
                annualPlanMacroCycles: this.annualPlanMacroCycles,
                dialogTitle: 'MacroCycleAdd',
            }
        });

        this.subscriptions.push(
            this.macroCycleDialog.afterClosed().subscribe((data:any) => {
                // add a phase to corresponding week
                if (data.annualPlanMacroCycle && !data.toDelete) {

                    // ajoute un tag
                    data.annualPlanMacroCycle.tag = this.utils.getUniqTag();

                    // ajoute aux cycles
                    this.annualPlanMacroCycles.push(data.annualPlanMacroCycle);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public annualPlanMacroCycleClickedEvent(annualPlanMacroCycle: AnnualPlanMacroCycle) {
        this.macroCycleDialog = this.dialog.open(AnnualPlanDialogFormMacrocycleComponent, {
            data: {
                organization: this.organization,
                annualPlanMacroCycle,
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                annualPlanMacroCycles: this.annualPlanMacroCycles,
                dialogTitle: 'MacroCycleEdit',
            }
        });

        this.subscriptions.push(
            this.macroCycleDialog.afterClosed().subscribe((data: any) => {

                // c'est une suppression
                if (data && data.toDelete && data.annualPlanMacroCycle) {

                    // liste des phases existantes à supprimer
                    this.annualPlanMacroCyclesToDelete.push(annualPlanMacroCycle.id!);

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanMacroCycles.findIndex((e) => e.tag === data.annualPlanMacroCycle.tag);
                    this.annualPlanMacroCycles.splice(index, 1);
                    // this.arrayUtils.removeFromArrayByReference(this.annualPlanMacroCycles, annualPlanMacroCycle);

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }

                // this is an update
                if (data && !data.toDelete && data.annualPlanMacroCycle) {

                    /**
                     * ! certain élément n'ont pas de id (les éléments créés qui ne
                     * sont pas enregistrés, n'en ont pas).
                     */
                    // @ts-ignore
                    const index = this.annualPlanMacroCycles.findIndex((e) => e.tag === data.annualPlanMacroCycle.tag);
                    this.annualPlanMacroCycles[index] = data.annualPlanMacroCycle;

                    this.changesGuard.registerChanges(() => this.onSaveClicked());
                }
            })
        );
    }

    public attributeEvent() {
        this.phaseDialog = this.dialog.open(AnnualPlanDialogFormAttributeComponent, {
            data: {
                annualPlan: this.annualPlan,
                weeks: this.weeks,
                organization: this.organization,
                dialogTitle: 'AttributePlan',
            }
        });

        this.subscriptions.push(
            this.phaseDialog.afterClosed().subscribe((data:any) => {
                if (data) {
                    this.toaster.open(this.translater.instant('AnnualPlan_Exported'), '', { duration: 5000 });
                }
            })
        );
    }

    public toggleEffectivePlan(event: MatSlideToggleChange) {
        this.showEffectivePlan = event.checked;
    }

    public handleClickedCommentFiled() {
        this.clickedWeek = undefined;
    }

    private loadData() {
        // Load athlete and annual plan if it exists
        this.subscriptions.push(
            this.route.data.subscribe((data: any) => { // { organization: Organization; athlete: Athlete; annualPlanData: AnnualPlanData; currentUser: User }
                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.annualPlanForm.patchValue(data.annualPlanData['plan']);
                this.annualPlan = data.annualPlanData['plan'];
                this.weeks = data.annualPlanData['weeks'];
                this.annualPlanPhases = data.annualPlanData['phases'];
                this.annualPlanMacroCycles = data.annualPlanData['macroCycles'];

                this.annualPlanRights.evaluateScreenRights({
                    rolesIds: this.currentUserRoles.getRolesIds(this.organization.id??0)
                });

                this.annualPlanRights.evaluateItemRight(this.annualPlan.rights);

                if (!this.annualPlan.hasRight(User.RIGHTS.VIEW)) {
                  this.is401 = true;
                  return;
                }
                if (this.isEditMode) {
                  if (!this.annualPlan.hasRight(User.RIGHTS.EDIT)) {
                    this.is401 = true;
                    return;
                  }
                }

                this.createPageTitle();
                this.createBreadcrumb();
                this.isLoading = false;


              // attribue des tags
                for (let i = 0; i < this.annualPlanPhases.length; i++) {
                    // @ts-ignore
                    this.annualPlanPhases[i].tag = this.utils.getUniqTag();
                }
                for (let i = 0; i < this.annualPlanMacroCycles.length; i++) {
                    // @ts-ignore
                    this.annualPlanMacroCycles[i].tag = this.utils.getUniqTag();
                }
            })
        );

        this.subscriptions.push(
            this.exerciseProvider.getExerciseCategories(this.organization).subscribe((categories) => {
                this.exerciseCategories = categories;
            })
        );

        this.subscriptions.push(
            this.phaseProvider.findAll(this.organization).subscribe((phases) => {
                this.phases = phases;
            })
        );

        this.subscriptions.push(
            this.annualPlanService.findAllByAthleteWithoutPlansInMap(this.organization, this.athleteUser.athlete!, [this.annualPlan]).subscribe((annualPlans) => {
                this.titleSwitcherItems = annualPlans.map((annualPlan) => ({ title: annualPlan.title!, icon: null, url: null, onClick: () => this.switchAnnualPlan(annualPlan) }));
            })
        );
    }

    private createPageTitle() {
        this.pageTitle = this.annualPlan.title ?? '';
        this._title.setTitle(this.pageTitle + ' | ' + this.conf.platformName);
    }

    private createBreadcrumb() {

        const crumbs: Crumb[] = [];
        if (!this.currentUserRoles.have(OrganizationRole.ID_ATHLETE, this.organization.id?? 0)) {
            crumbs.push({
                shortTitle: 'Athletes',
                title: 'Athletes',
                url: '/' + this.organization!.code + '/athletes'
            });
        }
        crumbs.push({
            shortTitle: this.athleteUser.firstName?.substr(0, 1) + '. ' + this.athleteUser.lastName,
            title: this.athleteUser.firstName + ' ' + this.athleteUser.lastName,
            url: '/' + this.organization!.code + '/athletes/' + this.athleteUser.id
        });
        crumbs.push({
            shortTitle: this.translater.instant('Annual_plans'),
            title: this.translater.instant('Annual_plans'),
            url: '/' + this.organization!.code + '/athletes/' + this.athleteUser.id + '/plans'
        });
        crumbs.push({
            shortTitle: this.annualPlan.title ?? '',
            title: this.annualPlan.title ?? '',
            url: '/' + this.organization!.code + '/athletes/' + this.athleteUser.id + '/plans/' + this.annualPlan.id
        });
        if (this.isEditMode) {
            crumbs.push({
                shortTitle: 'Edition',
                title: 'Edition',
                url: '/' + this.organization!.code + '/athletes/' + this.athleteUser.id + '/plans/' + this.annualPlan.id + '/edit'
            });
        }
        this.breadcrumbProvider.setDefaultCrumbs(crumbs);
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 404) {
            this.is404 = true;
        } else if (error.status === 401) {
            this.is401 = true;
        }
    }

}
